import React from 'react';

const DesktopContainer = props => {
  return <div className="br-lg" {...props} />;
};

export default DesktopContainer;
